import { Location } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';

import { switchMap } from 'rxjs/operators';
import * as _ from 'underscore';

import { BetslipDataService } from '../../../betslip/services/betslip/betslip-data.service';
import { BetslipService } from '../../../betslip/services/betslip/betslip.service';
import { ToteBetslipService } from '../../../betslip/services/toteBetslip/tote-betslip.service';
import { CommandService } from '../../../core/services/communication/command/command.service';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { DeviceService } from '../../../core/services/device/device.service';
import { DialogService } from '../../../core/services/dialogService/dialog.service';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { GtmTrackingService } from '../../../core/services/gtmTracking/gtm-tracking.service';
import { InfoDialogService } from '../../../core/services/infoDialogService/info-dialog.service';
import { LocaleService } from '../../../core/services/locale/locale.service';
import { NativeBridgeService } from '../../../core/services/nativeBridge/native-bridge.service';
import { QuickbetDataProviderService } from '../../../core/services/quickbetDataProviderService/quickbet-data-provider.service';
import { BETSLIP, IRemoteBetslipBet } from '../../../core/services/remoteBetslip/remote-betslip.constant';
import { RemoteBetslipService } from '../../../core/services/remoteBetslip/remote-betslip.service';
import { ScorecastDataService } from '../../../core/services/scorecastData/scorecast-data.service';
import { SessionStorageService } from '../../../core/services/storage/session-storage.service';
import { StorageService } from '../../../core/services/storage/storage.service';
import { UserService } from '../../../core/services/user/user.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { ArcUserService } from '../../../lazy-modules/arcUser/service/arcUser.service';
import { AWSFirehoseService } from '../../../lazy-modules/awsFirehose/service/aws-firehose.service';
import { RacingPostTipService } from '../../../lazy-modules/racingPostTip/service/racing-post-tip.service';
import { QuickbetComponent } from '../../../quickbet/components/quickbet/quickbet.component';
import { IQuickbetReceiptDetailsModel, ISRMBetPlacementModel } from '../../../quickbet/models/quickbet-receipt.model';
import { QuickbetDepositService } from '../../../quickbet/services/quickbetDepositService/quickbet-deposit.service';
import { QuickbetNotificationService } from '../../../quickbet/services/quickbetNotificationService/quickbet-notification.service';
import { QuickbetOveraskService } from '../../../quickbet/services/quickbetOveraskService/quickbet-overask.service';
import { RendererService } from '../../../shared/services/renderer/renderer.service';
import { SRMQuickbetService } from '../../services/srm-quickbet.service';

@Component({
    selector: 'srm-quickbet',
    templateUrl: 'srm-quickbet.component.html',
    standalone: false,
})
export class SrmQuickbetComponent extends QuickbetComponent {
    errorCodes = ['EVENT_SUSPENDED', 'MARKET_SUSPENDED', 'SELECTION_SUSPENDED', 'EVENT_STARTED'];
    constructor(
        locale: LocaleService,
        pubsub: PubSubService,
        gtm: GtmService,
        protected srmQuickbetService: SRMQuickbetService,
        remoteBsService: RemoteBetslipService,
        quickbetOverAskService: QuickbetOveraskService,
        command: CommandService,
        dialogService: DialogService,
        infoDialogService: InfoDialogService,
        device: DeviceService,
        nativeBridgeService: NativeBridgeService,
        location: Location,
        quickbetDataProviderService: QuickbetDataProviderService,
        rendererService: RendererService,
        windowRef: WindowRefService,
        gtmTrackingService: GtmTrackingService,
        quickbetDepositService: QuickbetDepositService,
        quickbetNotificationService: QuickbetNotificationService,
        awsService: AWSFirehoseService,
        changeDetectorRef: ChangeDetectorRef,
        userService: UserService,
        sessionStorage: SessionStorageService,
        racingPostTipService: RacingPostTipService,
        arcUserService: ArcUserService,
        protected override storageService: StorageService,
        protected override betslipService: BetslipService,
        protected override scorecastDataService: ScorecastDataService,
        protected override toteBetslipService: ToteBetslipService,
        protected override betslipDataService: BetslipDataService,
    ) {
        super(
            locale,
            pubsub,
            gtm,
            srmQuickbetService,
            remoteBsService,
            quickbetOverAskService,
            command,
            dialogService,
            infoDialogService,
            device,
            nativeBridgeService,
            location,
            quickbetDataProviderService,
            rendererService,
            windowRef,
            gtmTrackingService,
            quickbetDepositService,
            quickbetNotificationService,
            awsService,
            changeDetectorRef,
            userService,
            sessionStorage,
            racingPostTipService,
            arcUserService,
            storageService,
            betslipService,
            scorecastDataService,
            toteBetslipService,
            betslipDataService,
        );
        this.tag = 'SrmQuickbet';
    }

    override placeBetListener(): void {
        this.isPlaceBetSubscribetExist();
        this.quickbetPlaceBetSubscriber = this.quickbetDataProviderService.quickbetPlaceBetListener
            .pipe(
                switchMap((bet: IRemoteBetslipBet) => {
                    this.betplacementProcess = true;
                    return this.srmQuickbetService.srmPlaceBet(bet);
                }),
            )
            .subscribe(
                (result: ISRMBetPlacementModel[]) => {
                    const myBets: any = result[0].bet;
                    myBets.isquickbet = true;
                    this.trackSRMPlaceBetSuccess(result, this.trackObj);
                    this.srmQuickbetService.removeQBStateFromStorage();
                    this.quickbetDataProviderService.quickbetReceiptListener.next(result);
                    this.quickbetNotificationService.clear();
                    this.removeSubscribers();
                    this.pubsub.publishSync(this.pubsub.API.BET_PLACED, BETSLIP.QUICKBET);
                    this.pubsub.publishSync(this.pubsub.API.MY_BET_PLACED, myBets);
                    this.pubsub.publish(this.pubsub.API.BETS_COUNTER_PLACEBET);
                    this.pubsub.publish('PRIVATE_MARKETS_TAB');
                    if (this.selection) {
                        this.selection.skipOnReconnect = true;
                    }
                    const placeBetReceipt = result && result[0];
                    this.placeBetFn.emit(placeBetReceipt);
                    this.isBetPlaceClicked = false;
                    this.isBetReceiptShown = true;
                    this.sessionStorage.remove('isSRMBet');
                    /**
                     * set event id to Local storage when placed a bet
                     */
                    let signPostingData = this.storageService.get('myBetsSignPostingData');
                    if (this!.selectionData!.eventId && signPostingData?.length > 0) {
                        const eventIndex = signPostingData.findIndex((data: any) => Number(data.eventId) === Number(this.selectionData!.eventId!));
                        if (eventIndex > -1) {
                            const betIndex = signPostingData[eventIndex].betIds.findIndex((id: number) => Number(id) == Number(result[0].betId));
                            if (betIndex < 0) {
                                signPostingData[eventIndex].betIds.push(result[0].betId);
                            }
                        } else {
                            const eventObj = { eventId: this!.selectionData!.eventId, betIds: [result[0].betId] };
                            signPostingData.push(eventObj);
                        }
                        this.storageService.set('myBetsSignPostingData', signPostingData);
                    } else {
                        signPostingData = [{ eventId: this!.selectionData!.eventId, betIds: [result[0].betId] }];
                        this.storageService.set('myBetsSignPostingData', signPostingData);
                    }
                },
                (error = {}) => {
                    this.removeSubscribers();
                    this.betIsPlaced = true;
                    this.isBetReceiptShown = false;

                    if (error.betError && error.betError[0]) {
                        error.code = error.betError[0].betFailureKey;
                        error.message = error.betError[0].betFailureReason;
                    }
                    if (error.betMinStake || error.betMaxStake) {
                        error.stake = {
                            maxAllowed: error.betMaxStake,
                            minAllowed: error.betMinStake,
                        };
                    }

                    if (error.code !== 'OVERASK') {
                        let errorMessage = this.srmQuickbetService.getBetPlacementErrorMessage(error, this.selectionData!, true);
                        if (this.errorCodes.includes(error.code)) {
                            this!.selectionData!.disabled = true;
                        }
                        if (error.code === 'SELECTION_SUSPENDED') {
                            errorMessage = this.locale.getString('quickbet.betPlacementErrors.OUTCOME_SUSPENDED');
                        }
                        this.trackPlaceBetError(error, this.trackObj, errorMessage);

                        this.quickbetDataProviderService.quickbetReceiptListener.next(<IQuickbetReceiptDetailsModel[]>[
                            { error: errorMessage, errorCode: error.subErrorCode },
                        ]);
                    }
                    if (error.code === '4016') {
                        this.pubsub.publish(this.pubsub.API.SHOW_LOCATION_RESTRICTED_BETS_DIALOG);
                    }
                },
            );
    }

    /**
     * Fire success SRM bet placement event to Google Analytics
     * @param receipt {object}
     * @param trackingInfo {object}
     */
    trackSRMPlaceBetSuccess(receipt: ISRMBetPlacementModel[], trackingInfo: any): void {
        if (receipt && receipt[0]) {
            if (trackingInfo.hasOwnProperty('ecommerce')) {
                const price = Number(this!.selectionData!.stake || 0);
                const bonus = Number(this!.selectionData!.freebetValue || 0);
                const odds = this.srmOdds;

                trackingInfo.eventLabel = 'success';
                trackingInfo.ecommerce.purchase.actionField = {
                    id: receipt[0].receipt,
                    revenue: price + bonus,
                };

                trackingInfo.ecommerce.purchase.products[0] = _.extend(trackingInfo.ecommerce.purchase.products[0], {
                    name: this.selectionEventLocalTime + ' ' + this!.selectionData!.typeName,
                    id: receipt[0].receipt,
                    price: price + bonus,
                    quantity: 1,
                    category: String(this!.selectionData!.categoryId),
                    variant: String(this!.selectionData!.typeId),
                    brand: this.locale.getString('racing.srmTabName').toLowerCase(),
                    dimension60: String(this!.selectionData!.eventId),
                    dimension61: String(this!.selectionData!.outcomeId),
                    dimension62: this!.selectionData!.isStarted ? 1 : 0,
                    dimension63: this!.selectionData!.isYourCallBet ? 1 : 0,
                    dimension64: this.selectionEventLocalTime,
                    dimension65: 'racecard',
                    dimension66: Number(receipt![0].bet!.leg![0]!.part!.length),
                    dimension67: +odds,
                    dimension86: 0,
                    dimension87: 0,
                    dimension88: null,
                    dimension166: 'normal',
                    dimension180: this!.selectionData!.categoryId == '39' ? 'virtual' : 'normal',
                    metric1: bonus,
                });
                if (this.stakeFromQb) {
                    const dimVal = this.stakeFromQb == 2 ? 'keypad predefined stake' : 'predefined stake';
                    trackingInfo.ecommerce.purchase.products[0]['dimension181'] = dimVal;
                }
                this.stakeFromQb = 0;
                this.digitKeyBoardStatus = false;
                if (this!.selection!.GTMObject!['betData'] && this!.selection!.GTMObject!['betData']['dimension94']) {
                    const trackingObj = {
                        dimension90: receipt[0].bet.betId,
                        dimension94: this!.selection!.GTMObject!['betData']['dimension94'],
                    };
                    trackingInfo.ecommerce.purchase.products[0] = { ...trackingInfo.ecommerce.purchase.products[0], ...trackingObj };
                }
                if (this.scorecastData && this.scorecastData.length > 0 && this.scorecastData[0]['eventLocation'] === 'scorecast') {
                    trackingInfo = { ...trackingInfo, ...this.ecommerceObj };
                }
                if (trackingInfo.ecommerce.purchase.products[0].dimension65 === 'next events') {
                    trackingInfo.ecommerce.purchase.products[0]['dimension180'] = 'virtual_hub';
                }
                this.sendEventToGTM(trackingInfo);
            } else {
                if (this.scorecastData.length > 0 && this.scorecastData[0]['eventLocation'] === 'scorecast') {
                    trackingInfo = { ...trackingInfo, ...this.ecommerceObj };
                }
                this.sendEventToGTM(_.extend({}, { eventLabel: 'success', betID: receipt[0].receipt }, trackingInfo));
            }
        }
    }

    override ngOnDestroy(): void {
        this.sessionStorage.remove('isSRMBet');
        this.pubsub.unsubscribe(this.tag);
    }
}
